export default class gridItemsHeights {
  constructor() {

    document.body.addEventListener("recommendations-loaded", e => {
      // if(document.querySelector('[data-mh="grid-images"]') !== null) {
      //   this.init1();
      // }

      if (document.querySelector('[data-mh="grid-description"]') !== null) {
        this.init2();
      }

      if (document.querySelector('[data-mh="product-titles"]') !== null) {
        this.init3();
      }
    });
  }

  // init1() {
  //     $('[data-mh="grid-description"]').matchHeight({
  //       byRow: true,
  //       property: 'height',
  //       target: null,
  //       remove: false
  //     });
  // }

  init2() {
    $('[data-mh="grid-images"]').matchHeight({
      byRow: true,
      property: 'height',
      target: null,
      remove: false
    });
  }

  init3() {
    $('[data-mh="product-titles"]').matchHeight({
      byRow: true,
      property: 'height',
      target: null,
      remove: false
    });
  }
}
